var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.unreadCount)?_c('div',{class:_vm.containerClass,on:{"mouseenter":_vm.displayLabel,"mouseleave":_vm.hideLabel}},[_c('b-icon-envelope',{staticStyle:{"width":"20px","height":"20px","margin-top":"1px"}}),_c('div',{staticClass:"status-indicator__label"},[_vm._v(" "+_vm._s(_vm.$tc('n-new-messages', this.unreadCount))+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }